module.exports = __webpack_public_path__ + "media/re.45d7e5e3.mp4";